import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

import type { Contact as ContactType, ContactsTask, TaskFormState } from 'bundles/apex/tasks/types';

interface Props {
  contacts: ContactType[];
  contactsTask: ContactsTask;
  onChange: (contactsTask: ContactsTask) => void;
  onDelete: (contactsTask: ContactsTask) => void;
}

export default function Contact({ contacts, contactsTask, onChange, onDelete }: Props) {
  return (
    <div className="d-flex align-items-center mb-3">
      <ManagedInput
        className="form-control mr-3"
        includeBlank
        label="Contact"
        type="select"
        value={contactsTask.contact.id}
        onValueChange={contactId => {
          onChange({
            ...contactsTask,
            contact: contacts.find(contact => contact.id === parseInt(contactId))!,
          });
        }}
      >
        <Options
          options={[contactsTask.contact, ...contacts]}
          valueName="id"
        />
      </ManagedInput>

      <FontAwesomeIcon
        className="clickable"
        icon={faTrash}
        onClick={() => onDelete(contactsTask)}
      />
    </div>
  );
}
